import { ref, computed, nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a3d5730"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top_title"
}, "基础信息", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "2px"
  }
}, "日单量", -1));
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "gap": "8px",
    "align-items": "center"
  }
};
const _hoisted_6 = {
  class: "tips"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top_title"
}, "监控维度配置", -1));
const _hoisted_8 = {
  class: "tips"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top_title"
}, "监控指标配置", -1));
const _hoisted_10 = {
  class: "flex flex-align-center"
};
const _hoisted_11 = {
  class: "tips fixed_tips"
};
const _hoisted_12 = {
  class: "flex flex-align-center"
};
const _hoisted_13 = {
  class: "tips fixed_tips"
};
const _hoisted_14 = {
  class: "option_setting_wrap"
};
const _hoisted_15 = {
  key: 0,
  class: "option_setting_left"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));
const _hoisted_17 = ["title"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line"
}, null, -1));
const _hoisted_19 = {
  style: {
    "margin-left": "6px"
  }
};
const _hoisted_20 = {
  class: "flex"
};
const _hoisted_21 = {
  style: {
    "margin-left": "6px"
  }
};
const _hoisted_22 = {
  style: {
    "margin-left": "6px",
    "display": "flex",
    "align-items": "baseline",
    "flex": "1"
  }
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "%", -1));
const _hoisted_24 = {
  style: {
    "min-width": "fit-content",
    "margin-left": "16px",
    "margin-right": "34px"
  }
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 1,
  style: {
    "width": "28px"
  }
};
const _hoisted_27 = {
  class: "footer-btn"
};
import { reportEvent } from '@/common';
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import MultipleProductSelectComp from '@/components/CustomMultipleProductSelect.vue';
import SvgIcon from '@/components/SvgIcon';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import { getMetricTypeListFetch, upsertWarningTaskFetch, validateFeishuChatInfoFetch } from '@/api/orderMonitor';
import useBaseList from '../hooks/useBaseList';
import { ENABLE_STATUS_OPTIONS, CHOOSE_TYPE_OPTIONS, CHOOSE_TYPE, productVersionBaisicList, productVersionCompareBasicList, COMPARE_RANGE_OPTIONS, TASK_TRIGGER_TYPE, TASK_TRIGGER_TYPE_OPTIONS, PRODUCT_VERSION, ENABLE_STATUS, COMPARE_RANGE, DEFAUL_TRIGGER_TIME } from '../data';
export default {
  __name: 'addDrawer',
  props: {
    userLoading: Boolean,
    userSearchTip: String,
    userList: {
      type: Array,
      default: () => []
    },
    thresholdPlanList: {
      type: Array,
      default: () => []
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['reflashTable', 'searchUsers', 'openUsers', 'closeUsers'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const isViewMode = ref(false);
    const drawVisible = ref(false);
    const productVersionList = ref(productVersionBaisicList);
    const productVersionCompareList = ref(productVersionCompareBasicList);
    const formData = reactive({
      enable: ENABLE_STATUS.ON,
      taskName: '',
      // 预警任务名称
      studioIds: [0],
      // 工作室id列表
      orderScaleThreshold: '',
      // 产品日订单量大于等于的阈值
      triggerType: TASK_TRIGGER_TYPE.HOURLY,
      // 触发规则
      triggerTiming: DEFAUL_TRIGGER_TIME,
      // 触发时间
      notifyUserIds: [],
      notifyFeishuChatName: '',
      remark: '',
      dbtIds: [],
      // 产品id列表
      appVer: PRODUCT_VERSION.ALL,
      comparedAppVer: PRODUCT_VERSION.ALL,
      comparedRange: COMPARE_RANGE.LAST_7_PERIODS,
      // 数据采样周期
      enableModel: false,
      enableFixValue: false,
      logicOperator: 1,
      chooseType: CHOOSE_TYPE.SPECIFIED_PRODUCT,
      // 选品方式
      fixedValueRules: [] //固定值规则
    });
    // 已选快照独立于当前查询，历史缺失字段与 ID 类型原样保留。
    const selectedNotifyUsers = ref(new Map());
    const notifyOptions = computed(() => props.userList.map(item => ({
      ...item,
      value: String(item.value)
    })));
    const notifySelection = computed({
      get: () => formData.notifyUserIds.map(id => {
        var _selectedNotifyUsers$, _selectedNotifyUsers$2;
        return {
          value: String(id),
          label: (_selectedNotifyUsers$ = (_selectedNotifyUsers$2 = selectedNotifyUsers.value.get(String(id))) === null || _selectedNotifyUsers$2 === void 0 ? void 0 : _selectedNotifyUsers$2.notifyUser) !== null && _selectedNotifyUsers$ !== void 0 ? _selectedNotifyUsers$ : ''
        };
      }),
      set: values => {
        formData.notifyUserIds = values.map(item => String(typeof item === 'object' ? item.value : item));
      }
    });
    const loading = ref(false);
    const isValidatingNotifyGroups = ref(false);
    const isGroupValidated = ref(false); // 群组是否已验证通过
    const groupValidateError = ref(''); // 群组验证错误提示
    const formRef = ref();
    const rowId = ref(null);
    const indicatorEnumList = ref([]); //指标
    const {
      studioList
    } = useBaseList();
    const orderScaleThresholdRules = [{
      validator: validateOrderScaleThreshold
    }];

    // 校验提醒人和提醒群组至少填写一个
    function validateNotifyRequired() {
      const hasNotifyUsers = Array.isArray(formData.notifyUserIds) && formData.notifyUserIds.length > 0;
      const hasNotifyGroup = formData.notifyFeishuChatName && formData.notifyFeishuChatName.trim() !== '';
      if (!hasNotifyUsers && !hasNotifyGroup) {
        return Promise.reject('请至少选择提醒人或输入提醒群组');
      }
      return Promise.resolve();
    }
    const notifyRules = [{
      validator: validateNotifyRequired
    }];

    // 当提醒人或提醒群组改变时，触发两个字段的校验
    const handleNotifyChange = () => {
      const selected = new Map();
      formData.notifyUserIds = [...new Set(formData.notifyUserIds.map(String))];
      formData.notifyUserIds.forEach(id => {
        const old = selectedNotifyUsers.value.get(id);
        const candidate = props.userList.find(item => String(item.value) === id);
        if (old) selected.set(id, old);else if (candidate) selected.set(id, {
          notifyUserId: candidate.value,
          notifyUser: candidate.label
        });
      });
      selectedNotifyUsers.value = selected;
      // 延迟执行，确保值已更新
      nextTick(() => {
        var _formRef$value;
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validateFields(['notifyUserIds', 'notifyFeishuChatName']).catch(() => {
          // 忽略校验错误，让表单自己显示
        });
      });
    };

    // 当提醒群组输入改变时，清除验证状态
    const handleGroupInputChange = () => {
      isGroupValidated.value = false;
      groupValidateError.value = ''; // 清除错误提示
      handleNotifyChange();
    };

    //打开弹窗
    const showModal = async row => {
      drawVisible.value = true;
      if (row !== null && row !== void 0 && row.taskId) {
        //编辑
        rowId.value = row.taskId;
        initEditData(row);
      } else {
        //新增
        initAddData();
      }
      if (!isViewMode.value) emit('openUsers');
      getIndicatorList(); //获取固定值的指标选项列表
    };

    // 查看模式（只读）
    const showView = row => {
      isViewMode.value = true;
      showModal(row);
    };
    function validateOrderScaleThreshold(_rule, value) {
      if (value === undefined || value === null || value === '') {
        return Promise.resolve();
      }
      const isNumeric = /^\d+(\.\d+)?$/.test(String(value));
      return isNumeric ? Promise.resolve() : Promise.reject('只能输入数字');
    }
    const onClose = () => {
      emit('closeUsers');
      selectedNotifyUsers.value = new Map();
      formRef.value.resetFields();
      drawVisible.value = false;
      isViewMode.value = false;
    };
    const getIndicatorList = async () => {
      try {
        const {
          code,
          data
        } = await getMetricTypeListFetch();
        if (code === '0') {
          indicatorEnumList.value = Array.isArray(data) ? data.map(({
            indicatorCode,
            indicatorName,
            valueType
          }) => ({
            label: indicatorName,
            value: indicatorCode,
            isRatio: valueType === 0,
            disabled: false
          })) : [];
          if (!rowId.value) {
            //新增时，默认添加第一项
            formData.fixedValueRules = [];
            addRuleRow();
          }
        }
      } catch (error) {}
    };
    const initEditData = async row => {
      try {
        var _detailInfo$dbtIds, _detailInfo$notifyFei, _detailInfo$indicator, _detailInfo$indicator2, _detailInfo$indicator3;
        const detailInfo = row !== null && row !== void 0 ? row : {};
        formData.enable = detailInfo.enable;
        formData.taskName = detailInfo.taskName;
        formData.chooseType = CHOOSE_TYPE.SPECIFIED_PRODUCT;
        formData.dbtIds = (_detailInfo$dbtIds = detailInfo.dbtIds) !== null && _detailInfo$dbtIds !== void 0 ? _detailInfo$dbtIds : [];
        formData.triggerType = detailInfo.triggerType;
        formData.triggerTiming = detailInfo.triggerTiming ? detailInfo.triggerTiming : DEFAUL_TRIGGER_TIME;
        selectedNotifyUsers.value = new Map((detailInfo.notifyUserInfo || []).map(item => [String(item.notifyUserId), {
          ...item
        }]));
        formData.notifyUserIds = [...selectedNotifyUsers.value.keys()];
        formData.notifyFeishuChatName = (_detailInfo$notifyFei = detailInfo.notifyFeishuChatName) !== null && _detailInfo$notifyFei !== void 0 ? _detailInfo$notifyFei : '';
        // 编辑时如果有群组，标记为已验证（因为是从后端获取的已保存数据）
        isGroupValidated.value = !!detailInfo.notifyFeishuChatName;
        formData.remark = detailInfo.remark;
        formData.appVer = detailInfo.appVer;
        formData.comparedAppVer = detailInfo.comparedAppVer;
        formData.comparedRange = detailInfo.comparedRange;
        formData.enableModel = detailInfo.enableModel === 1 ? true : false;
        formData.enableFixValue = detailInfo.enableFixValue === 1 ? true : false;
        formData.logicOperator = ((_detailInfo$indicator = detailInfo.indicatorValue) === null || _detailInfo$indicator === void 0 || (_detailInfo$indicator = _detailInfo$indicator[0]) === null || _detailInfo$indicator === void 0 ? void 0 : _detailInfo$indicator.logicOperator) === 'and' ? 2 : 1;
        formData.fixedValueRules = (_detailInfo$indicator2 = (_detailInfo$indicator3 = detailInfo.indicatorValue) === null || _detailInfo$indicator3 === void 0 ? void 0 : _detailInfo$indicator3.map(item => ({
          indicatorEnum: item === null || item === void 0 ? void 0 : item.indicatorCode,
          judgmentSymbol: '<',
          thresholdValue: item === null || item === void 0 ? void 0 : item.minimumValueLowerLimit,
          isRatio: true
        }))) !== null && _detailInfo$indicator2 !== void 0 ? _detailInfo$indicator2 : [];
      } catch (error) {}
    };
    const addRuleRow = () => {
      // 标记已经选中的指标（使用 Set 提升查找效率）
      const selected = new Set(formData.fixedValueRules.map(rule => rule.indicatorEnum));
      indicatorEnumList.value.forEach(item => {
        item.disabled = selected.has(item.value);
      });

      // 选择第一个未被禁用的指标
      const next = indicatorEnumList.value.find(item => !item.disabled);
      if (!next) return;
      formData.fixedValueRules.push({
        indicatorEnum: next.value,
        isRatio: next.isRatio,
        judgmentSymbol: '<',
        thresholdValue: null
      });
      next.disabled = true;
    };
    const deleRuleRow = i => {
      formData.fixedValueRules.splice(i, 1);
      // 基于剩余规则重算禁用状态，确保一致性
      const selected = new Set(formData.fixedValueRules.map(rule => rule.indicatorEnum));
      indicatorEnumList.value.forEach(item => {
        item.disabled = selected.has(item.value);
      });
    };

    // 每个指标只能选择一次
    const changeEnum = (value, index) => {
      var _indicatorEnumList$va;
      // 基于当前规则集合一次性重算禁用状态
      const selected = new Set(formData.fixedValueRules.map(rule => rule.indicatorEnum));
      indicatorEnumList.value.forEach(item => {
        item.disabled = selected.has(item.value);
      });
      formData.fixedValueRules[index].judgmentSymbol = '<';
      formData.fixedValueRules[index].isRatio = (_indicatorEnumList$va = indicatorEnumList.value.find(item => item.value === value)) === null || _indicatorEnumList$va === void 0 ? void 0 : _indicatorEnumList$va.isRatio;
    };
    const getParams = () => {
      const params = {
        ...formData
      };

      // 处理按条件筛选和指定产品的参数
      if (formData.chooseType === CHOOSE_TYPE.BY_CONDITION) {
        // 按条件筛选
        params.studioIds = formData.studioIds;
        // 产品订单量级选择大于等于
        params.scale = formData.orderScaleThreshold;

        // 删除选中的产品参数
        delete params.dbtIds;
      } else {
        // 指定产品
        params.dbtIds = formData.dbtIds;
        delete params.studioIds;
        delete params.orderScaleThreshold;
      }
      delete params.chooseType;

      // 处理提醒人参数
      params.notifyUserInfo = formData.notifyUserIds.map(id => selectedNotifyUsers.value.get(String(id)));
      delete params.notifyUserIds;

      // 处理固定值规则
      params.indicatorValue = formData.enableFixValue ? formData.fixedValueRules.map(item => {
        var _indicatorEnumList$va2;
        return {
          indicatorCode: item.indicatorEnum,
          indicatorName: (_indicatorEnumList$va2 = indicatorEnumList.value.find(temp => temp.value === item.indicatorEnum)) === null || _indicatorEnumList$va2 === void 0 ? void 0 : _indicatorEnumList$va2.label,
          minimumValueLowerLimit: item.thresholdValue,
          logicOperator: formData.logicOperator === 2 ? 'and' : 'or'
        };
      }) : [];
      params.enableFixValue = formData.enableFixValue ? 1 : 0;
      delete params.fixedValueRules;
      delete params.logicOperator;
      params.enableModel = formData.enableModel ? 1 : 0;
      // todo 2025/12/25 应产品需求，暂时屏蔽掉数科预警模型的配置
      delete params.enableModel;
      delete params.triggerTiming; // 删除触发规则的具体时间参数

      // 编辑
      if (rowId.value) {
        params.taskId = rowId.value;
      }
      return params;
    };
    const onSave = () => {
      if (isViewMode.value) return;

      // 如果填写了提醒群组，检查是否已验证
      if (formData.notifyFeishuChatName && formData.notifyFeishuChatName.trim() !== '') {
        if (!isGroupValidated.value) {
          groupValidateError.value = '请先验证提醒群组';
          return;
        }
      }
      formRef.value.validate().then(async () => {
        try {
          loading.value = true;
          const params = getParams();
          const {
            code
          } = await upsertWarningTaskFetch(params);
          if (code == '0') {
            message.success('保存成功!');
            emit('reflashTable');
            onClose();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '预警任务',
                element_name: '保存'
              }
            });
          }
        } catch (error) {}
        loading.value = false;
      }).catch(error => {});
    };
    const onValidateNotifyGroups = async () => {
      if (isViewMode.value) return;
      const feishuChatName = formData.notifyFeishuChatName;
      if (!feishuChatName) {
        groupValidateError.value = '请填写提醒群组';
        return;
      }
      try {
        isValidatingNotifyGroups.value = true;
        groupValidateError.value = ''; // 清除之前的错误
        const {
          code,
          data
        } = await validateFeishuChatInfoFetch({
          feishuChatName
        });
        if (code === '0') {
          formData.notifyFeishuChatId = data.feishuChatId;
          message.success('验证通过');
          isGroupValidated.value = true; // 标记验证成功
          groupValidateError.value = ''; // 清除错误提示
        } else {
          groupValidateError.value = '验证失败，请检查群组名称';
          formData.notifyFeishuChatName = '';
          isGroupValidated.value = false;
        }
      } finally {
        isValidatingNotifyGroups.value = false;
      }
    };
    const initAddData = () => {
      selectedNotifyUsers.value = new Map();
      formData.enable = ENABLE_STATUS.ON;
      formData.taskName = '';
      formData.studioIds = [0];
      formData.orderScaleThreshold = '';
      formData.triggerType = TASK_TRIGGER_TYPE.HOURLY;
      formData.triggerTiming = DEFAUL_TRIGGER_TIME;
      formData.notifyUserIds = [];
      formData.notifyFeishuChatName = '';
      formData.remark = '';
      formData.dbtIds = [];
      formData.appVer = PRODUCT_VERSION.ALL;
      formData.comparedAppVer = PRODUCT_VERSION.ALL;
      formData.comparedRange = COMPARE_RANGE.LAST_7_PERIODS;
      formData.enableModel = false;
      formData.enableFixValue = false;
      formData.logicOperator = 1;
      formData.chooseType = CHOOSE_TYPE.SPECIFIED_PRODUCT;
      formData.fixedValueRules = [];
      rowId.value = null;
      indicatorEnumList.value = [];
      isGroupValidated.value = false; // 重置验证状态
      groupValidateError.value = ''; // 清除错误提示
    };
    const changeStudio = e => {
      formData.studioIds = e;
      if (e[e.length - 1] === 0) {
        formData.studioIds = [0];
      } else if (e[0] == 0) {
        formData.studioIds.splice(0, 1);
      }
    };

    // 切换 左侧逻辑显示 与 预警方案（1=或，2=且）
    const changeJointMode = () => {
      formData.logicOperator = formData.logicOperator === 2 ? 1 : 2;
    };
    expose({
      showModal,
      showView
    });
    return (_ctx, _cache) => {
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_form_item_rest = _resolveComponent("a-form-item-rest");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_time_picker = _resolveComponent("a-time-picker");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_drawer, {
        placement: "right",
        title: "预警任务设置",
        width: "710px",
        open: drawVisible.value,
        "onUpdate:open": _cache[18] || (_cache[18] = $event => drawVisible.value = $event),
        class: _normalizeClass(['waring-draw', {
          'view-mode': isViewMode.value
        }]),
        onClose: onClose,
        closable: false,
        maskClosable: false
      }, {
        extra: _withCtx(() => [_createVNode(_unref(CloseOutlined), {
          onClick: onClose,
          class: "close_icon"
        })]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: formData,
          ref_key: "formRef",
          ref: formRef,
          layout: "horizontal",
          "label-col": {
            style: {
              width: '108px'
            }
          },
          class: "waring_form_wrap"
        }, {
          default: _withCtx(() => [_hoisted_1, _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "预警状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                  value: formData.enable,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.enable = $event),
                  disabled: isViewMode.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ENABLE_STATUS_OPTIONS), opt => {
                    return _openBlock(), _createBlock(_component_a_radio, {
                      key: opt.value,
                      value: opt.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "任务名称",
                name: "taskName",
                rules: [{
                  required: true,
                  message: '请输入预警任务名称'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: formData.taskName,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.taskName = $event),
                  disabled: isViewMode.value,
                  placeholder: "预警任务名称"
                }, null, 8, ["value", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "选品方式"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                  value: formData.chooseType,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.chooseType = $event),
                  disabled: isViewMode.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CHOOSE_TYPE_OPTIONS), opt => {
                    return _openBlock(), _createBlock(_component_a_radio, {
                      key: opt.value,
                      value: opt.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), formData.chooseType == _unref(CHOOSE_TYPE).BY_CONDITION ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "工作室",
                name: "studioIds",
                rules: [{
                  required: false,
                  message: '请选择工作室'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.studioIds,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.studioIds = $event),
                  mode: "multiple",
                  optionFilterProp: "label",
                  maxTagCount: "responsive",
                  onChange: changeStudio,
                  showArrow: "",
                  showSearch: "",
                  options: _unref(studioList),
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode;
                  }
                }, null, 8, ["value", "options", "disabled", "getPopupContainer"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "orderScaleThreshold",
                rules: orderScaleThresholdRules
              }, {
                label: _withCtx(() => [_hoisted_2]),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: ">",
                    style: {
                      "flex": "1"
                    }
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_select_option, {
                      key: ">",
                      value: ">"
                    }, {
                      default: _withCtx(() => [_createTextVNode("大于")]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_input_number, {
                  style: {
                    "flex": "2",
                    "margin-left": "8px"
                  },
                  placeholder: "订单数量",
                  disabled: isViewMode.value,
                  value: formData.orderScaleThreshold,
                  "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.orderScaleThreshold = $event)
                }, null, 8, ["disabled", "value"])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row)], 64)) : _createCommentVNode("", true), formData.chooseType == _unref(CHOOSE_TYPE).SPECIFIED_PRODUCT ? (_openBlock(), _createBlock(_component_a_row, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "dbtIds",
                label: "选择产品",
                rules: [{
                  required: true,
                  message: '请选择产品'
                }]
              }, {
                default: _withCtx(() => [_createVNode(MultipleProductSelectComp, {
                  width: "100%",
                  valueField: "dbtId",
                  labelField: "appName",
                  value: formData.dbtIds,
                  "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.dbtIds = $event),
                  productList: __props.productList,
                  showFooter: true,
                  allowClear: true,
                  maxTagCount: 40,
                  disabled: isViewMode.value
                }, null, 8, ["value", "productList", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_form_item, {
                class: "flex-1",
                label: "触发规则"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.triggerType,
                  "onUpdate:value": _cache[6] || (_cache[6] = $event => formData.triggerType = $event),
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TASK_TRIGGER_TYPE_OPTIONS), opt => {
                    return _openBlock(), _createBlock(_component_a_select_option, {
                      key: opt.value,
                      value: opt.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value", "disabled", "getPopupContainer"])]),
                _: 1
              }), false && formData.triggerType == _unref(TASK_TRIGGER_TYPE).HOURLY ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                style: {
                  "width": "120px",
                  "margin-left": "4px"
                },
                name: "triggerTiming",
                rules: [{
                  required: true,
                  message: '请选择时间'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_time_picker, {
                  value: formData.triggerTiming,
                  "onUpdate:value": _cache[7] || (_cache[7] = $event => formData.triggerTiming = $event),
                  disabled: isViewMode.value,
                  format: "HH:mm:ss",
                  "value-format": "HH:mm:ss",
                  "minute-step": 60,
                  "second-step": 60,
                  "show-now": false,
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["value", "disabled"])]),
                _: 1
              })) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyUserIds",
                label: "提醒人",
                rules: notifyRules
              }, _createSlots({
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  placeholder: "请选择提醒人（可多选）",
                  value: _unref(notifySelection),
                  "onUpdate:value": _cache[8] || (_cache[8] = $event => _isRef(notifySelection) ? notifySelection.value = $event : null),
                  labelInValue: "",
                  mode: "multiple",
                  optionFilterProp: "label",
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  },
                  options: _unref(notifyOptions),
                  filterOption: false,
                  loading: __props.userLoading,
                  notFoundContent: __props.userSearchTip || '未找到人员',
                  onSearch: _cache[9] || (_cache[9] = $event => emit('searchUsers', $event)),
                  showSearch: "",
                  showArrow: "",
                  onChange: handleNotifyChange
                }, null, 8, ["value", "disabled", "getPopupContainer", "options", "loading", "notFoundContent"])]),
                _: 2
              }, [__props.userSearchTip ? {
                name: "extra",
                fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.userSearchTip), 1)]),
                key: "0"
              } : undefined]), 1024)]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                name: "notifyFeishuChatName",
                label: "提醒群组",
                rules: notifyRules,
                "validate-status": groupValidateError.value ? 'error' : '',
                help: groupValidateError.value
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_input, {
                  style: {
                    "flex": "1"
                  },
                  placeholder: "请输入提醒群组",
                  value: formData.notifyFeishuChatName,
                  "onUpdate:value": _cache[10] || (_cache[10] = $event => formData.notifyFeishuChatName = $event),
                  disabled: isViewMode.value,
                  onInput: handleGroupInputChange
                }, null, 8, ["value", "disabled"]), _createVNode(_component_a_button, {
                  ghost: "",
                  type: "primary",
                  size: "small",
                  disabled: isViewMode.value,
                  loading: isValidatingNotifyGroups.value,
                  onClick: onValidateNotifyGroups
                }, {
                  default: _withCtx(() => [_createTextVNode(" 验证 ")]),
                  _: 1
                }, 8, ["disabled", "loading"])])]),
                _: 1
              }, 8, ["validate-status", "help"])]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(InfoCircleOutlined), {
            class: "tips-icon"
          }), _createTextVNode(" 添加“内购消息通知机器人”入群后，点击“验证”验证群名称是否正确 ")]), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "备注",
                name: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_textarea, {
                  value: formData.remark,
                  "onUpdate:value": _cache[11] || (_cache[11] = $event => formData.remark = $event),
                  disabled: isViewMode.value,
                  placeholder: "请输入备注",
                  showCount: "",
                  autoSize: "",
                  maxlength: 200
                }, null, 8, ["value", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _hoisted_7, _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "当前数据版本"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.appVer,
                  "onUpdate:value": _cache[12] || (_cache[12] = $event => formData.appVer = $event),
                  options: productVersionList.value,
                  showArrow: "",
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  }
                }, null, 8, ["value", "options", "disabled", "getPopupContainer"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "采样数据版本"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.comparedAppVer,
                  "onUpdate:value": _cache[13] || (_cache[13] = $event => formData.comparedAppVer = $event),
                  options: productVersionCompareList.value,
                  showArrow: true,
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  }
                }, null, 8, ["value", "options", "disabled", "getPopupContainer"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(InfoCircleOutlined), {
            class: "tips-icon"
          }), _createTextVNode(" 当前数据版本：数据发生时段所选择版本的数据；采样数据版本：参考计算均值7日数据版本 ")]), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "数据采样周期",
                rules: [{
                  required: true,
                  message: '请选择数据采样周期'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.comparedRange,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => formData.comparedRange = $event),
                  showArrow: true,
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  },
                  placeholder: "请选择数据采样周期"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMPARE_RANGE_OPTIONS), opt => {
                    return _openBlock(), _createBlock(_component_a_select_option, {
                      key: opt.value,
                      value: opt.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(opt.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value", "disabled", "getPopupContainer"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _hoisted_9, false ? (_openBlock(), _createBlock(_component_a_row, {
            key: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                style: {
                  "margin-left": "16px"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_a_checkbox, {
                  checked: formData.enableModel,
                  "onUpdate:checked": _cache[15] || (_cache[15] = $event => formData.enableModel = $event),
                  disabled: isViewMode.value
                }, {
                  default: _withCtx(() => [_createTextVNode(" 是否开启数科预警模型 ")]),
                  _: 1
                }, 8, ["checked", "disabled"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_unref(InfoCircleOutlined), {
                  class: "tips-icon"
                }), _createTextVNode(" 系统将根据产品的日订单量级别自动匹配阈值方案 ")])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                style: {
                  "margin-left": "16px"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createVNode(_component_a_checkbox, {
                  checked: formData.enableFixValue,
                  "onUpdate:checked": _cache[16] || (_cache[16] = $event => formData.enableFixValue = $event),
                  disabled: isViewMode.value
                }, {
                  default: _withCtx(() => [_createTextVNode("设置固定值")]),
                  _: 1
                }, 8, ["checked", "disabled"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_unref(InfoCircleOutlined), {
                  class: "tips-icon"
                }), _createTextVNode(" 此处为指标固定下限阈值，当低于该阈值时触发预警，如果不开启，则取阈值方案的配置 ")])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_Transition, {
            name: "expand-vertical"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_14, [formData.fixedValueRules.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", {
              class: "text",
              onClick: _cache[17] || (_cache[17] = $event => !isViewMode.value && changeJointMode()),
              title: formData.logicOperator === 2 ? '点击切换为或' : '点击切换为且'
            }, _toDisplayString(formData.logicOperator === 2 ? '且' : '或'), 9, _hoisted_17), _hoisted_18])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.fixedValueRules, (k, index) => {
              return _openBlock(), _createBlock(_component_a_row, {
                key: k
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createVNode(_component_a_select, {
                  value: k.indicatorEnum,
                  "onUpdate:value": $event => k.indicatorEnum = $event,
                  showArrow: true,
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  },
                  style: {
                    "width": "200px"
                  },
                  onChange: $event => changeEnum($event, index)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicatorEnumList.value, k => {
                    return _openBlock(), _createBlock(_component_a_select_option, {
                      key: k.value,
                      value: k.value,
                      label: k.label,
                      disabled: k.disabled
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(k.label), 1)]),
                      _: 2
                    }, 1032, ["value", "label", "disabled"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "disabled", "getPopupContainer", "onChange"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_a_select, {
                  value: k.judgmentSymbol,
                  "onUpdate:value": $event => k.judgmentSymbol = $event,
                  showArrow: true,
                  disabled: isViewMode.value,
                  getPopupContainer: triggerNode => {
                    return triggerNode.parentNode || _ctx.document.body;
                  },
                  style: {
                    "width": "100px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select_option, {
                    value: "<"
                  }, {
                    default: _withCtx(() => [_createTextVNode("低于")]),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "disabled", "getPopupContainer"])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_a_form_item, {
                  label: "",
                  name: ['fixedValueRules', index, 'thresholdValue'],
                  style: {
                    "width": "100%"
                  },
                  rules: [{
                    required: formData.enableFixValue,
                    message: '请输入'
                  }, {
                    pattern: /^([1-9]\d*(\.\d+)?|0\.\d+)$/,
                    message: '请输入数字'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    style: {
                      "width": "180px"
                    },
                    value: k.thresholdValue,
                    "onUpdate:value": $event => k.thresholdValue = $event,
                    disabled: isViewMode.value,
                    placeholder: k.isRatio ? '请输入百分比' : '请输入数值'
                  }, _createSlots({
                    _: 2
                  }, [k.isRatio ? {
                    name: "suffix",
                    fn: _withCtx(() => [_hoisted_23]),
                    key: "0"
                  } : undefined]), 1032, ["value", "onUpdate:value", "disabled", "placeholder"])]),
                  _: 2
                }, 1032, ["name", "rules"]), _createElementVNode("div", _hoisted_24, [formData.fixedValueRules.length > 1 && !isViewMode.value ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: $event => deleRuleRow(index)
                }, "删除", 8, _hoisted_25)) : (_openBlock(), _createElementBlock("div", _hoisted_26))])])])]),
                _: 2
              }, 1024);
            }), 128)), formData.fixedValueRules.length < indicatorEnumList.value.length && !isViewMode.value ? (_openBlock(), _createBlock(_component_a_row, {
              key: 0
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                onClick: addRuleRow
              }, [_createVNode(_unref(SvgIcon), {
                "icon-class": "openIcon",
                "class-name": "add-icon"
              }), _createTextVNode(" 添加更多监控指标 ")])]),
              _: 1
            })) : _createCommentVNode("", true)])], 512), [[_vShow, formData.enableFixValue]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_27, [isViewMode.value ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "primary",
          onClick: onClose
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_a_button, {
          onClick: onClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          loading: loading.value,
          onClick: onSave,
          style: {
            "margin-left": "20px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }, 8, ["loading"])], 64))])]),
        _: 1
      }, 8, ["open", "class"])]);
    };
  }
};